import React from 'react'
import { NavLink } from 'react-router-dom'
import './Layout.css'

export default function SideNav() {
  const linkClass = ({ isActive }) => 'navlink' + (isActive ? ' active' : '')
  return (
    <aside className="sidenav">
      <NavLink to="/dashboard" className={linkClass}>Dashboard</NavLink>
      <NavLink to="/summary" className={linkClass}>Summary</NavLink>
      <NavLink to="/analytics" className={linkClass}>Analytics</NavLink>
      <NavLink to="/management" className={linkClass}>Management</NavLink>
    </aside>
  )
}
